import axios from '@/utils/api'

const actions = {
  async getLaudosByIdProcesso ({ commit }, idProcesso) {
    const data = await axios({
      method: 'GET',
      url: `monitoramentoAmbiental/laudos/processo/${idProcesso}`
    })
    return data
  },
  async regerarByIdProcesso ({ commit }, idProcesso) {
    return axios({
      method: 'PUT',
      url: `monitoramentoAmbiental/regerar/processo/${idProcesso}`
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/monitoramentoAmbiental.js